import { Component, contentChild, ElementRef, EventEmitter, Input, Output, viewChild } from '@angular/core';
import { uniqueId } from 'lodash-es';

@Component({
	selector: 'schir-int-client-file-upload',
	templateUrl: './file-upload.component.html',
	styleUrls: ['./file-upload.component.scss'],
	standalone: false,
})
export class FileUploadComponent {
	readonly contentChildButton = contentChild<ElementRef>('fileUploadButton');
	readonly fileInput = viewChild<ElementRef<HTMLInputElement>>('fileInput');

	@Input() accept: string = '*/*';

	@Output() fileChanged: EventEmitter<File> = new EventEmitter();

	readonly defaultLabel: string = 'Datei hochladen';
	readonly myId: string = uniqueId();

	onFileChanged($event: Event) {
		const files = (<HTMLInputElement>$event.target).files;
		this.fileChanged.emit(files[0]);
	}

	clear() {
		this.fileInput().nativeElement.value = null;
	}

	openElement() {
		this.fileInput().nativeElement.click();
	}
}
